/*
 * @Descripttion: your project
 * @version: 1.0
 * @Author: zxy
 * @Date: 2022-08-02 09:23:35
 * @LastEditors: 张馨元 zhangxy@iynss.com
 * @LastEditTime: 2025-02-19 10:42:58
 */
import { get,post } from "../request";
const common = {
  /***
   * 字典操作接口
   * @param dictTypeCode
   */
  dictionaryOper: dictTypeCode => {
    return get("/web/dictEntity/getByDictType", dictTypeCode);
  },
  /***
   *  获取市场行情柱状图数据
   */

  getMarketHistogram: () => {
    return get("/web/productMarketEntity/getMarketHistogram");
  },

  /**
   * 按月获取野生菌市场价格
   * @param annual//年
   * @param month//月份
   */

  getMarketPriceByMonth: (year, month) => {
    return get(
      "/web/mushroomTradingMonth/marketConditions?annual=" +
        year +
        "&month=" +
        month
    );
  },
  // /***
  //  *  获取企业列表
  //  */

  // getCompanyList: () => {
  //   return get("/web/corporateInfoEntity/getOptionsList");
  // },
  // /***
  //  * 获取企业详细信息
  //  */

  // getCompanyDetailInfo: id => {
  //   return get("/web/corporateInfoEntity/getById?id=" + id);
  // },
  /**
   * 获取企业下拉信息
   * */
  getCompanySelectInfo: () => {
    return post("/web/enterpriseInfoEntity/selectList");
  },
  /**
   * 获取企业详细信息
   * */
  getCompanyDetailInfo:(id)=>{
    return get("/web/enterpriseInfoEntity/getById?id="+id)
  },
  /**
   * 获取底部信息
   * */

  getFooterBasicInfo: () => {
    return get("/web/basisEntity/qurey");
  }
};
export default common;



// WEBPACK FOOTER //
// ./src/api/modules/common.js